import { JsonSchema } from '@sagold/react-json-editor';

export const jsonEditorDataMocks = {
  formFields: [
    {
      metadataId: '25630a15-85e4-44e0-8b31-20ce20e0aefc',
      singleSelectInUpload: true,
      requiredInUpload: true,
      displayFormat: null,
      type: 'keywordReferenced',
      key: 'target_type',
      name: 'Target type',
      referenceKey: 'id',
      referenceFields: ['target_type'],
      referenceTable: 'v_all_target_types',
      mappingColumnName: 'target_type_id',
      mappingTableName: 'v_investor_mf_category_relation',
      conditionalFilter: true,
      conditionallyRequired: false,
      conditionalMetadataFilter: null,
      conditionalMetadataId: null,
    },
    {
      metadataId: '46848efe-224b-4881-b9e1-f53885c18ea1',
      singleSelectInUpload: true,
      requiredInUpload: false,
      displayFormat: null,
      type: 'keywordReferenced',
      key: 'connection_type',
      name: 'Investment Relationship',
      referenceKey: 'id',
      referenceFields: ['connection_type'],
      referenceTable: 'v_all_connection_types',
      mappingColumnName: 'connection_type_id',
      mappingTableName: 'v_investor_mf_category_relation',
      conditionalFilter: true,
      conditionallyRequired: false,
      conditionalMetadataFilter: null,
      conditionalMetadataId: null,
    },
    {
      metadataId: '138aa310-349f-443e-9943-17a177f60be6',
      singleSelectInUpload: true,
      requiredInUpload: false,
      displayFormat: null,
      type: 'keywordReferenced',
      key: 'fund_category',
      name: 'Fund Category',
      referenceKey: 'id',
      referenceFields: ['name'],
      referenceTable: 'v_all_category_names',
      mappingColumnName: 'mf_category',
      mappingTableName: 'v_investor_mf_category_relation',
      conditionalFilter: true,
      conditionallyRequired: true,
      conditionalMetadataFilter: { nin: ['2'] },
      conditionalMetadataId: '25630a15-85e4-44e0-8b31-20ce20e0aefc',
    },
    {
      metadataId: 'a6020c9b-aad4-4eb7-a2da-3d260676fe28',
      singleSelectInUpload: true,
      requiredInUpload: true,
      displayFormat: null,
      type: 'keywordReferenced',
      key: 'fund',
      name: 'Fund',
      referenceKey: 'id',
      referenceFields: ['name'],
      referenceTable: 'v_all_fund_names',
      mappingColumnName: 'mf_object_unique_id',
      mappingTableName: 'v_investor_mf_category_relation',
      conditionalFilter: true,
      conditionallyRequired: false,
      conditionalMetadataFilter: null,
      conditionalMetadataId: null,
    },
    {
      metadataId: '402d5fc5-99e8-4602-9a90-5021b5b83e6a',
      singleSelectInUpload: false,
      requiredInUpload: false,
      displayFormat: null,
      type: 'keywordReferenced',
      key: 'investor',
      name: 'Investor',
      referenceKey: 'id',
      referenceFields: ['name'],
      referenceTable: 'v_all_investor_names',
      mappingColumnName: 'inv_object_unique_id',
      mappingTableName: 'v_investor_mf_category_relation',
      conditionalFilter: true,
      conditionallyRequired: true,
      conditionalMetadataFilter: {
        in: [
          '15',
          '6',
          '4',
          '27',
          '23',
          '24',
          '25',
          '17',
          '26',
          '30',
          '16',
          '28',
          '29',
          '18',
        ],
      },
      conditionalMetadataId: '3e03b601-3a7b-4df5-ab24-00a7e389743d',
    },
    {
      metadataId: '3e03b601-3a7b-4df5-ab24-00a7e389743d',
      singleSelectInUpload: true,
      requiredInUpload: true,
      displayFormat: null,
      type: 'keywordReferenced',
      key: 'document_type',
      name: 'Document Type',
      referenceKey: 'id',
      referenceFields: ['name'],
      referenceTable: 'all_document_types',
      mappingColumnName: 'internal_id',
      mappingTableName: 'v_all_document_types_mapping',
      conditionalFilter: true,
      conditionallyRequired: false,
      conditionalMetadataFilter: null,
      conditionalMetadataId: null,
    },
    {
      metadataId: '0f24e457-2af8-44fe-8def-b2d2c0a00ae8',
      singleSelectInUpload: true,
      requiredInUpload: false,
      displayFormat: null,
      type: 'keywordReferenced',
      key: 'share_type',
      name: 'Share type',
      referenceKey: 'id',
      referenceFields: ['share_type'],
      referenceTable: 'v_all_share_types',
      mappingColumnName: 'share_type_id',
      mappingTableName: 'v_investor_mf_category_relation',
      conditionalFilter: true,
      conditionallyRequired: true,
      conditionalMetadataFilter: {
        in: [
          '15',
          '6',
          '4',
          '27',
          '23',
          '24',
          '25',
          '17',
          '26',
          '30',
          '16',
          '28',
          '29',
          '18',
        ],
      },
      conditionalMetadataId: '3e03b601-3a7b-4df5-ab24-00a7e389743d',
    },
    {
      metadataId: 'f6931b29-0cdd-4388-a3d2-57317601abb2',
      singleSelectInUpload: true,
      requiredInUpload: false,
      displayFormat: null,
      type: 'date',
      key: 'period_end',
      name: 'Reference Date',
      referenceKey: '',
      referenceFields: [],
      referenceTable: '',
      mappingColumnName: null,
      mappingTableName: null,
      conditionalFilter: false,
      conditionallyRequired: false,
      conditionalMetadataFilter: null,
      conditionalMetadataId: null,
    },
  ],
  formSchema: {
    type: 'object',
    required: [
      'target_type',
      'connection_type',
      'fund_category',
      'fund',
      'investor',
      'document_type',
      'share_type',
      'period_end',
    ],
    properties: {
      target_type: {
        type: 'array',
        default: [],
        items: { type: 'string' },
        title: 'Target type',
        options: { placeholder: 'Please select a value', required: true },
        minItems: 1,
        maxItems: 1,
        conditionalFilter: {
          dataGroup: 'v_investor_mf_category_relation',
          dataProperty: 'target_type_id',
        },
      },
      connection_type: {
        type: 'array',
        default: [],
        items: { type: 'string' },
        title: 'Investment Relationship',
        options: { placeholder: 'Please select a value' },
        maxItems: 1,
        conditionalFilter: {
          dataGroup: 'v_investor_mf_category_relation',
          dataProperty: 'connection_type_id',
        },
      },
      fund_category: {
        type: 'array',
        default: [],
        items: { type: 'string' },
        title: 'Fund Category',
        options: { placeholder: 'Please select a value' },
        maxItems: 1,
        conditionalFilter: {
          dataGroup: 'v_investor_mf_category_relation',
          dataProperty: 'mf_category',
        },
      },
      fund: {
        type: 'array',
        default: [],
        items: { type: 'string' },
        title: 'Fund',
        options: { placeholder: 'Please select a value', required: true },
        minItems: 1,
        maxItems: 1,
        conditionalFilter: {
          dataGroup: 'v_investor_mf_category_relation',
          dataProperty: 'mf_object_unique_id',
        },
      },
      investor: {
        type: 'array',
        default: [],
        items: { type: 'string' },
        title: 'Investor',
        options: { placeholder: 'Please select a value' },
        conditionalFilter: {
          dataGroup: 'v_investor_mf_category_relation',
          dataProperty: 'inv_object_unique_id',
        },
      },
      document_type: {
        type: 'array',
        default: [],
        items: { type: 'string' },
        title: 'Document Type',
        options: { placeholder: 'Multiple values *', readOnly: true },
        maxItems: 1,
        conditionalFilter: {
          dataGroup: 'v_all_document_types_mapping',
          dataProperty: 'internal_id',
        },
      },
      share_type: {
        type: 'array',
        default: [],
        items: { type: 'string' },
        title: 'Share type',
        options: { placeholder: 'Multiple values *' },
        maxItems: 1,
        conditionalFilter: {
          dataGroup: 'v_investor_mf_category_relation',
          dataProperty: 'share_type_id',
        },
      },
      period_end: {
        type: 'string',
        format: 'date',
        title: 'Reference Date',
        options: { placeholder: 'Please select a date' },
      },
    },
    allOf: [
      {
        if: {
          properties: {
            target_type: { minItems: 1, items: { not: { enum: ['2'] } } },
          },
        },
        then: {
          properties: {
            fund_category: {
              options: { required: true },
              minItems: 1,
              minLength: 1,
            },
          },
        },
      },
      {
        if: {
          properties: {
            document_type: {
              minItems: 1,
              items: {
                enum: [
                  '15',
                  '6',
                  '4',
                  '27',
                  '23',
                  '24',
                  '25',
                  '17',
                  '26',
                  '30',
                  '16',
                  '28',
                  '29',
                  '18',
                ],
              },
            },
          },
        },
        then: {
          properties: {
            investor: {
              options: { required: true },
              minItems: 1,
              minLength: 1,
            },
          },
        },
      },
      {
        if: {
          properties: {
            document_type: {
              minItems: 1,
              items: {
                enum: [
                  '15',
                  '6',
                  '4',
                  '27',
                  '23',
                  '24',
                  '25',
                  '17',
                  '26',
                  '30',
                  '16',
                  '28',
                  '29',
                  '18',
                ],
              },
            },
          },
        },
        then: {
          properties: {
            share_type: {
              options: { required: true },
              minItems: 1,
              minLength: 1,
            },
          },
        },
      },
    ],
  } as JsonSchema,
  modalValuesResponse: {
    target_type_id: { values: ['2', '1'], labels: ['IF', 'MF'] },

    connection_type_id: {
      values: ['1', '2', '0'],
      labels: ['Direct', 'Lookthrough', 'NOT_APPLICABLE'],
    },

    mf_category: {
      values: [
        'A4',
        'BB3/BBD',
        'BB4',
        'Category I',
        'Category II',
        'Demo Diversified',
        'EMAS',
        'EMAS PM',
        'EMAS RE',
        'EMAS2',
        'EMAS3',
        'FACP',
        'FAIP',
        'G2',
        'MSIM',
        'P1',
        'PR 1',
        'PR 2',
        'PR 3',
        'S2',
        'S4',
        'S8',
        'SG K F',
        'Secondary',
      ],
      labels: [
        'A4',
        'BB3/BBD',
        'BB4',
        'Category I',
        'Category II',
        'Demo Diversified',
        'EMAS',
        'EMAS PM',
        'EMAS RE',
        'EMAS2',
        'EMAS3',
        'FACP',
        'FAIP',
        'G2',
        'MSIM',
        'P1',
        'PR 1',
        'PR 2',
        'PR 3',
        'S2',
        'S4',
        'S8',
        'SG K F',
        'Secondary',
      ],
    },

    mf_object_unique_id: {
      values: [
        'FND0011786',
        'TFND0007286',
        'FND0012262',
        'FND0012261',
        'TFND0005449',
        'TFND0005451',
        'TFND0002657',
        'FND0011247',
        'FND0011248',
        'FND0011249',
        'FND0011250',
        'FND0011251',
        'FND0011638',
        'TFND0005467',
        'TFND0005469',
        'FND0011254',
        'FND0012083',
        'FND0011255',
        'FND0011256',
        'FND0011257',
        'FND0012233',
        'FND0012245',
        'FND0012362',
        'FND0012156',
        'FND0012259',
        'FND0012003',
        'FND0012004',
        'FND0011963',
        'FND0011964',
        'FND0011965',
        'FND0011968',
        'FND0011969',
        'FND0011970',
        'FND0011971',
        'FND0011972',
        'FND0011973',
        'FND0011856',
        'FND0011912',
        'FND0012006',
        'FND0011914',
        'FND0012007',
        'FND0012008',
        'FND0011911',
        'FND0012137',
        'FND0011962',
        'FND0011939',
        'FND0011940',
        'FND0011941',
        'TFND0010331',
        'TFND0008244',
        'TFND0008280',
        'TFND0008182',
        'TFND0008194',
        'TFND0000198',
        'TFND0007557',
        'TFND0007646',
        'TFND0011047',
        'TFND0008233',
        'TFND0010495',
        'TFND0000451',
        'TFND0000718',
        'TFND0008192',
        'TFND0008021',
        'TFND0000464',
        'TFND0007218',
        'TFND0010450',
        'TFND0004626',
        'TFND0008200',
        'TFND0002605',
        'TFND0008204',
        'TFND0008246',
        'TFND0008171',
        'TFND0008777',
        'TFND0008189',
        'TFND0008196',
        'TFND0005733',
        'TFND0005734',
        'TFND0005736',
        'TFND0008279',
        'TFND0008248',
        'TFND0008201',
        'TFND0010190',
        'TFND0010747',
        'TFND0008203',
        'TFND0008281',
        'TFND0007647',
        'TFND0008191',
        'TFND0008129',
        'TFND0008205',
        'TFND0005737',
        'TFND0008012',
        'TFND0007220',
        'TFND0003790',
        'TFND0008195',
        'TFND0008245',
        'TFND0010038',
        'TFND0006634',
        'TFND0008862',
        'TFND0008735',
        'TFND0000364',
        'TFND0007642',
        'TFND0009815',
        'TFND0006160',
        'TFND0008193',
        'TFND0008714',
        'TFND0008734',
        'TFND0006630',
        'TFND0008206',
        'TFND0000457',
        'TFND0008020',
        'TFND0000274',
        'TFND0000443',
        'TFND0008139',
        'TFND0007221',
        'TFND0008181',
        'TFND0008199',
        'TFND0006696',
        'TFND0010494',
        'TFND0008867',
        'TFND0006633',
        'TFND0006766',
        'TFND0009363',
        'TFND0010504',
        'TFND0008190',
        'TFND0007643',
        'TFND0000098',
        'TFND0008778',
        'TFND0008282',
        'TFND0005450',
        'TFND0008207',
        'TFND0010503',
        'TFND0006941',
        'FND0012551',
        'FND0012538',
        'FND0012546',
        'FND0012558',
        'FND0012554',
        'FND0012537',
        'FND0012550',
        'FND0012549',
        'TFND0005486',
        'FND0012547',
        'FND0012559',
        'FND0012555',
        'TFND0005674',
        'FND0012539',
        'FND0012553',
        'FND0012561',
        'FND0012552',
        'FND0012556',
        'FND0012560',
        'FND0012557',
        'FND0012563',
        'FND0012562',
        'FND0012548',
        'FND0012540',
        'FND0012544',
        'FND0012536',
        'FND0012535',
        'FND0012541',
        'FND0012542',
        'FND0012545',
        'FND0012543',
        'FND0012143',
        'FND0011663',
        'FND0011666',
        'FND0011769',
        'FND0011776',
        'FND0011777',
        'FND0012067',
        'FND0012115',
        'FND0011767',
        'FND0012438',
        'FND0112280',
        'FND0012199',
        'FND0012196',
        'FND0012193',
        'FND0012184',
        'FND0012185',
        'FND0012172',
        'FND0012192',
        'FND0012182',
        'FND0012170',
        'FND0012207',
        'FND0012161',
        'FND0012159',
        'FND0012165',
        'FND0012282',
        'FND0012171',
        'FND0012166',
        'FND0012158',
        'FND0012205',
        'FND0012163',
        'FND0012181',
        'FND0012169',
        'FND0012279',
        'FND0012281',
        'FND0012283',
        'FND0212280',
        'FND0012202',
        'FND0012177',
        'FND0012284',
        'FND0012160',
        'FND0012210',
        'FND0012190',
        'FND0012187',
        'FND0012174',
        'FND0012198',
        'FND0012178',
        'FND0012175',
        'FND0012183',
        'FND0012188',
        'FND0012189',
        'FND0012209',
        'FND0012186',
        'FND0012176',
        'FND0012173',
        'FND0012203',
        'FND0012195',
        'FND0012204',
        'FND0012164',
        'FND0012180',
        'FND0012208',
        'FND0012200',
        'FND0012201',
        'FND0012194',
        'FND0012191',
        'FND0012197',
        'FND0012285',
        'FND0012168',
        'FND0012179',
        'FND0012162',
        'FND0012167',
        'FND0012206',
        'FND0011676',
      ],
      labels: [
        '5R MF 3',
        'ASC 4 B',
        'AirFirst',
        'CPE China Fund IV',
        'Caplink Test case',
        'Carry Vehicle',
        'Debt Fund 2',
        'Demo Investee Fund 01',
        'Demo Investee Fund 02',
        'Demo Investee Fund 03',
        'Demo Investee Fund 04',
        'Demo Investee Fund 05',
        'Demo MF Ekinoxx ',
        'Demo Parallel Fund 4A',
        'Demo Parallel Fund 4C',
        'Demo Private Debt Corporate Fund',
        'Demo Private Debt Fund 1 LP',
        'Demo Private Debt Fund of Funds Euro Hedged',
        'Demo Private Debt Real Estate Fund',
        'Demo Private Equity Corporate Fund',
        'Demo transfer test fund ',
        'EMAS A Capital LLC',
        'EMAS A Real Estate 1 LLC',
        'EMAS C LLC',
        'EMAS EFA Capital LLC',
        'EMAS2 SPV PG3',
        'EMAS2 SPV PG4',
        'EMAS3 Investee Fund 1',
        'EMAS3 Investee Fund 2',
        'EMAS3 Investee Fund 3',
        'EMAS3 Investee Fund 4',
        'EMAS3 Investee Fund 5',
        'EMAS3 Investee Fund 6',
        'EMAS3 Investee Fund 7',
        'EMAS3 Investee Fund 8',
        'EMAS3 Investee Fund 9',
        'Emas Investee Fund 1',
        'Emas Investee Fund 2',
        'Emas Investee Fund 3',
        'Emas Investee Fund 3A',
        'Emas Investee Fund 4',
        'Emas Investee Fund 5',
        'Emas2 HoldCo LLC',
        'Emas2 investee fund 10',
        'Emas3 HoldCo LLC',
        'FUND I',
        'FUND II',
        'FUND III',
        'Fund 10023',
        'Fund 10064',
        'Fund 10076',
        'Fund 10078',
        'Fund 1008',
        'Fund 10145',
        'Fund 10337',
        'Fund 10390',
        'Fund 10601',
        'Fund 10790',
        'Fund 10808',
        'Fund 10883',
        'Fund 10957',
        'Fund 10995',
        'Fund 11067',
        'Fund 11093',
        'Fund 11270',
        'Fund 11459',
        'Fund 11591',
        'Fund 11879',
        'Fund 12104',
        'Fund 12157',
        'Fund 12340',
        'Fund 12544',
        'Fund 12586',
        'Fund 12590',
        'Fund 12771',
        'Fund 12881',
        'Fund 13108',
        'Fund 13333',
        'Fund 13440',
        'Fund 15095',
        'Fund 15133',
        'Fund 15201',
        'Fund 15388',
        'Fund 15651',
        'Fund 15673',
        'Fund 1594',
        'Fund 1640',
        'Fund 168',
        'Fund 17',
        'Fund 1832',
        'Fund 1940',
        'Fund 195',
        'Fund 2058',
        'Fund 2176',
        'Fund 2196',
        'Fund 2279',
        'Fund 2382',
        'Fund 2525',
        'Fund 2610',
        'Fund 2663',
        'Fund 2742',
        'Fund 2996',
        'Fund 3114',
        'Fund 3193',
        'Fund 3466',
        'Fund 4294',
        'Fund 4354',
        'Fund 4512',
        'Fund 4859',
        'Fund 5131',
        'Fund 521',
        'Fund 5379',
        'Fund 5555',
        'Fund 5827',
        'Fund 6031',
        'Fund 6059',
        'Fund 6071',
        'Fund 6101',
        'Fund 6161',
        'Fund 6203',
        'Fund 6458',
        'Fund 682',
        'Fund 7839',
        'Fund 7977',
        'Fund 8030',
        'Fund 8483',
        'Fund 8643',
        'Fund 8829',
        'Fund 9119',
        'Fund 939',
        'Fund 9626',
        'Fund 998',
        'Fund ACREF',
        'Fund AGNL',
        'Fund Ares US X',
        'Fund BREP Asia III',
        'Fund COREF',
        'Fund CPI',
        'Fund CPIF',
        'Fund CPOF',
        'Fund Conso MO',
        'Fund EICF IV',
        'Fund ERIF II',
        'Fund ESR JIF',
        'Fund Equity FA JP',
        'Fund GLP EIP II',
        'Fund GLP JIF',
        'Fund Hamburg',
        'Fund JMF II',
        'Fund JMF III',
        'Fund JMF IV',
        'Fund LAO VI',
        'Fund Lodz',
        'Fund Logistica',
        'Fund MASCOT',
        'Fund MERIT',
        'Fund MIRELF VIII',
        'Fund MUSEL EU',
        'Fund MUSEL NA',
        'Fund MUSIC',
        'Fund MUSLOG',
        'Fund PEDCF I',
        'Fund PELF',
        'Fund Z',
        'IF Sec 1',
        'IF Sec 2',
        'IF Sec 3',
        'IF Sec 4',
        'IF Sec 5',
        'IF Sec 6',
        'IF Sec 7',
        'MF FoF Secondary',
        'Master BO Fund',
        'Test ABC',
        'Test AirFirst',
        'Test Allied Universal',
        'Test AlpInvest Secondary Program VII',
        'Test Anggerik HV L.P.',
        'Test Anggerik-L L.P.',
        'Test Ardian Buyout Fund VII',
        'Test Ardian Secondary Fund VIII',
        'Test Bain Asia V',
        'Test Bain Capital XIII',
        'Test Belron',
        'Test Blackstone Capital Partners VIII',
        'Test CPE China Fund IV',
        'Test CVC Asia V',
        'Test CVC Capital Partners IX',
        'Test CVC Capital Partners VIII',
        'Test CVC Strategic Opportunities II',
        'Test CapVest V',
        'Test Carro',
        'Test Cinven VII',
        'Test Cinven VIII',
        'Test Clayton Dubilier & Rice XI',
        'Test Clayton Dubilier & Rice XII',
        'Test Crown Global Secondaries VI',
        'Test Cyclomedia',
        'Test DEF',
        'Test DomusVi',
        'Test EQT IX',
        'Test EQT X',
        'Test EagleTree Partners V',
        'Test Ensemble Health Partners',
        'Test General Atlantic (2022)',
        'Test General Atlantic Partners (Bermuda) IV L.P.',
        'Test Genstar X',
        'Test Genuone Sciences',
        'Test Great Hill Partners VIII',
        'Test Hellman & Friedman X',
        'Test Hellman & Friedman XI',
        'Test Insight Partners XI',
        'Test Insight Partners XII',
        'Test Internet Brands',
        'Test KKR CPS',
        'Test KKR North America XIII',
        'Test MBK Partners V',
        'Test MVP Terminalling',
        'Test MYOB',
        'Test Parexel',
        'Test Permira VII',
        'Test Permira VIII',
        'Test RAC',
        'Test Recipharm AB',
        'Test Stella and Chewy',
        'Test Strategic Partners IX',
        'Test Strategic Partners VIII',
        'Test TK Elevators',
        'Test TPG Asia VIII',
        'Test Thoma Bravo XIV',
        'Test Thoma Bravo XV',
        'Test Vista Equity Partners VII',
        'Test Vista Foundation Fund IV',
        'Test Yaneng Biopharma',
        'Transparency Test',
      ],
    },

    inv_object_unique_id: {
      values: [
        'FND0011779',
        'INV0006810',
        'INV0007101',
        'INV0007018',
        'INV0007019',
        'TFND0007286',
        'INV0007020',
        'INV0007021',
        'INV0007022',
        'INV0005966',
        'INV0006806',
        'TFND0005449',
        'TFND0005451',
        'TINV0000317',
        'FND0011678',
        'INV0005780',
        'INV0005779',
        'INV0006011',
        'INV0006012',
        'INV0006013',
        'FND0012084',
        'INV0006941',
        'FND0011255',
        'TFND0007269',
        'INV0006870',
        'FND0012245',
        'FND0012362',
        'FND0012156',
        'FND0012259',
        'INV0006844',
        'INV0006839',
        'INV0006843',
        'FND0011911',
        'FND0011962',
        'FND0011939',
        'FND0011940',
        'FND0011941',
        'FND0012439',
        'FND0012440',
        'FND0012441',
        'TFND0000174',
        'TFND0004626',
        'TFND0000456',
        'TFND0008171',
        'TFND0000279',
        'TFND0000442',
        'TFND0005894',
        'TFND0008129',
        'TFND0006295',
        'TFND0004661',
        'TFND0008139',
        'TFND0000463',
        'TFND0005452',
        'TFND0006766',
        'TFND0000450',
        'TFND0005674',
        'TINV0001980',
        'TINV0004198',
        'INV0006976',
        'INV0006985',
        'INV0006986',
        'INV0006987',
        'INV0006988',
        'INV0006989',
        'INV0006990',
        'INV0006991',
        'INV0006992',
        'INV0006993',
        'INV0006994',
        'INV0006977',
        'INV0006995',
        'INV0006996',
        'INV0006997',
        'INV0006998',
        'INV0006999',
        'INV0007000',
        'INV0006978',
        'INV0006979',
        'INV0006980',
        'INV0006981',
        'INV0006982',
        'INV0006983',
        'INV0006984',
        'INV0006815',
        'INV0006816',
        'INV0006818',
        'INV0006819',
        'INV0006862',
        'INV0006807',
        'INV0006808',
        'TINV0003468',
        'TINV0003546',
        'TINV0005521',
        'TINV0002076',
        'TINV0002954',
        'TINV0003077',
        'TINV0003829',
        'TINV0003664',
        'TINV0004522',
        'TINV0001720',
        'TINV0003410',
        'TINV0003757',
        'TINV0003268',
        'TINV0000043',
        'TINV0003853',
        'TINV0003557',
        'TINV0001719',
        'TINV0002061',
        'TINV0004519',
        'TINV0002832',
        'TINV0003633',
        'TINV0004881',
        'TINV0000202',
        'TINV0000229',
        'TINV0003631',
        'TINV0003969',
        'TINV0002077',
        'TINV0003962',
        'TINV0002059',
        'TINV0004219',
        'TINV0002936',
        'TINV0003765',
        'TINV0003391',
        'TINV0001735',
        'TINV0000208',
        'TINV0000626',
        'TINV0001711',
        'TINV0003821',
        'TINV0003263',
        'TINV0000193',
        'TINV0003009',
        'TINV0003095',
        'TINV0003604',
        'TINV0003762',
        'TINV0005189',
        'TINV0000224',
        'TINV0001134',
        'TINV0003556',
        'TINV0004439',
        'TINV0000206',
        'TINV0000232',
        'TINV0003649',
        'TINV0001572',
        'TINV0005545',
        'TINV0004851',
        'TINV0004116',
        'TINV0000205',
        'TINV0001731',
        'TINV0001721',
        'TINV0002056',
        'TINV0003386',
        'TINV0005546',
        'TINV0003491',
        'TINV0005530',
        'TINV0003825',
        'TINV0005592',
        'TINV0000203',
        'TINV0003356',
        'TINV0005288',
        'TINV0004225',
        'TINV0003668',
        'TINV0000271',
        'TINV0003525',
        'TINV0003011',
        'TINV0003728',
        'TINV0000041',
        'TINV0003542',
        'TINV0001724',
        'TINV0005203',
        'TINV0000642',
        'TINV0003972',
        'TINV0004199',
        'TINV0005003',
        'TINV0000325',
        'TINV0001573',
        'TINV0000212',
        'TINV0002078',
        'TINV0003662',
        'TINV0003506',
        'TINV0003019',
        'TINV0004434',
        'TINV0002067',
        'TINV0002616',
        'TINV0003588',
        'TINV0004764',
        'TINV0003948',
        'TINV0001198',
        'TINV0004119',
        'TINV0001709',
        'TINV0000209',
        'TINV0003015',
        'TINV0000252',
        'TINV0003304',
        'TINV0001199',
        'TINV0002956',
        'TINV0000341',
        'TINV0002949',
        'TINV0003836',
        'TINV0005739',
        'TINV0001213',
        'TINV0000197',
        'TINV0003372',
        'TINV0002071',
        'TINV0004757',
        'TINV0002950',
        'TINV0002963',
        'TINV0004124',
        'TINV0000489',
        'TINV0004091',
        'TINV0004934',
        'TINV0001730',
        'TINV0004857',
        'TINV0000228',
        'TINV0002068',
        'TINV0000501',
        'TINV0003854',
        'TINV0005308',
        'TINV0003253',
        'TINV0003340',
        'TINV0003965',
        'TINV0002066',
        'TINV0000056',
        'TINV0003517',
        'TINV0003971',
        'TINV0003495',
        'TINV0003704',
        'TINV0000200',
        'TINV0001272',
        'TINV0003848',
        'TINV0000371',
        'TINV0001734',
        'TINV0004867',
        'TINV0003655',
        'TINV0002182',
        'TINV0003875',
        'TINV0001574',
        'TINV0004131',
        'TINV0003334',
        'TINV0004200',
        'TINV0004191',
        'TINV0002951',
        'TINV0004130',
        'TINV0005313',
        'TINV0003630',
        'TINV0002074',
        'TINV0000204',
        'TINV0001712',
        'TINV0003008',
        'TINV0004125',
        'TINV0003574',
        'TINV0001702',
        'TINV0002959',
        'TINV0003492',
        'TINV0003671',
        'TINV0003607',
        'TINV0003565',
        'TINV0001732',
        'TINV0004846',
        'TINV0003387',
        'TINV0003869',
        'TINV0000491',
        'TINV0003643',
        'TINV0000196',
        'TINV0003563',
        'TINV0005608',
        'TINV0002054',
        'TINV0003820',
        'TINV0002823',
        'TINV0002971',
        'TINV0004169',
        'TINV0004928',
        'TINV0002275',
        'TINV0004197',
        'TINV0002072',
        'TINV0003793',
        'TINV0000199',
        'TINV0004929',
        'TINV0004678',
        'TINV0003759',
        'TINV0003837',
        'TINV0000190',
        'TINV0001722',
        'TINV0001704',
        'TINV0001728',
        'TINV0003013',
        'TINV0003080',
        'TINV0002822',
        'TINV0005055',
        'TINV0002075',
        'TINV0003014',
        'TINV0003550',
        'TINV0001726',
        'TINV0003094',
        'TINV0003538',
        'TINV0003215',
        'TINV0004118',
        'TINV0003270',
        'TINV0000343',
        'TINV0003831',
        'TINV0003347',
        'TINV0003018',
        'TINV0002105',
        'TINV0004536',
        'TINV0001729',
        'TINV0002958',
        'TINV0000191',
        'TINV0000625',
        'TINV0001715',
        'TINV0002953',
        'TINV0002079',
        'TINV0003448',
        'TINV0002060',
        'TINV0003721',
        'TINV0004521',
        'TINV0004154',
        'TINV0002833',
        'TINV0003828',
        'TINV0005597',
        'TINV0004861',
        'TINV0003533',
        'TINV0000495',
        'TINV0003017',
        'TINV0000624',
        'TINV0004117',
        'TINV0005192',
        'TINV0001725',
        'TINV0003834',
        'TINV0000347',
        'TINV0004436',
        'TINV0000490',
        'TINV0003634',
        'TINV0003822',
        'TINV0001858',
        'TINV0001706',
        'TINV0003968',
        'TINV0003706',
        'TINV0005208',
        'TINV0001200',
        'TINV0002062',
        'TINV0000225',
        'TINV0004933',
        'TINV0000654',
        'TINV0002946',
        'TINV0001714',
        'TINV0005195',
        'TINV0005005',
        'TINV0003083',
        'TINV0003763',
        'TINV0004848',
        'TINV0004863',
        'TINV0003355',
        'TINV0005515',
        'TINV0002070',
        'TINV0002276',
        'TINV0001713',
        'TINV0001271',
        'TINV0003316',
        'TINV0003629',
        'TINV0003368',
        'TINV0000321',
        'TINV0002945',
        'TINV0003835',
        'TINV0001723',
        'TINV0003555',
        'TINV0005321',
        'TINV0004862',
        'TINV0005709',
        'TINV0000496',
        'TINV0004440',
        'TINV0001201',
        'TINV0004860',
        'TINV0004297',
        'TINV0001703',
        'TINV0002800',
        'TINV0004818',
        'TINV0003534',
        'TINV0003589',
        'TINV0003605',
        'TINV0003644',
        'TINV0002952',
        'TINV0003016',
        'TINV0003636',
        'TINV0004032',
        'TINV0004129',
        'TINV0001716',
        'TINV0000487',
        'TINV0005512',
        'TINV0003705',
        'TINV0005301',
        'TINV0004126',
        'TINV0003403',
        'TINV0002960',
        'TINV0002065',
        'TINV0005517',
        'TINV0003838',
        'TINV0003537',
        'TINV0003970',
        'TINV0003306',
        'TINV0000357',
        'TINV0002915',
        'TINV0003447',
        'TINV0004637',
        'TINV0003963',
        'TINV0003946',
        'TINV0000655',
        'TINV0003952',
        'TINV0004049',
        'TINV0000195',
        'TINV0003453',
        'TINV0003830',
        'TINV0000348',
        'TINV0000210',
        'TINV0002917',
        'TINV0004847',
        'TINV0003354',
        'TINV0002955',
        'TINV0003726',
        'TINV0000351',
        'TINV0003305',
        'TINV0002961',
        'TINV0003396',
        'TINV0003925',
        'TINV0003551',
        'TINV0005312',
        'TINV0003269',
        'TINV0003526',
        'TINV0004856',
        'TINV0004122',
        'TINV0003267',
        'TINV0004866',
        'TINV0002916',
        'TINV0004672',
        'TINV0001132',
        'TINV0003960',
        'TINV0002057',
        'TINV0004196',
        'TINV0004652',
        'TINV0002976',
        'TINV0005197',
        'TINV0002834',
        'TINV0005547',
        'TINV0003823',
        'TINV0004525',
        'TINV0002615',
        'TINV0004930',
        'TINV0003266',
        'TINV0000226',
        'TINV0004220',
        'TINV0005303',
        'TINV0005609',
        'TINV0000207',
        'TINV0003261',
        'TINV0003764',
        'TINV0000054',
        'TINV0003847',
        'TINV0003826',
        'TINV0003336',
        'TINV0001183',
        'TINV0003564',
        'TINV0005194',
        'TINV0001006',
        'TINV0004864',
        'TINV0003657',
        'TINV0000494',
        'TINV0001710',
        'TINV0000493',
        'TINV0005198',
        'TINV0002069',
        'TINV0003586',
        'TINV0000344',
        'TINV0003339',
        'TINV0005309',
        'TINV0004859',
        'TINV0000350',
        'TINV0003265',
        'TINV0005738',
        'TINV0000985',
        'TINV0004852',
        'TINV0003079',
        'TINV0004853',
        'TINV0004752',
        'TINV0000492',
        'TINV0003818',
        'TINV0004817',
        'TINV0002073',
        'TINV0003012',
        'TINV0003606',
        'TINV0000488',
        'TINV0004435',
        'TINV0000627',
        'TINV0002055',
        'TINV0003219',
        'TINV0003006',
        'TINV0000623',
        'TINV0004222',
        'TINV0001717',
        'TINV0004816',
        'TINV0003967',
        'TINV0004224',
        'TINV0003942',
        'TINV0003758',
        'TINV0003446',
        'TINV0003819',
        'TINV0000365',
        'TINV0004680',
        'TINV0004849',
        'TINV0004762',
        'TINV0003441',
        'TINV0004233',
        'TINV0001718',
        'TINV0000194',
        'TINV0003007',
        'TINV0000051',
        'TINV0005206',
        'TINV0003262',
        'TINV0005207',
        'TINV0004230',
        'TINV0003715',
        'TINV0003648',
        'TINV0000622',
        'TINV0003260',
        'TINV0005737',
        'TINV0003824',
        'TINV0004190',
        'TINV0005655',
        'TINV0003661',
        'TINV0003489',
        'TINV0004441',
        'TINV0003827',
        'TINV0004865',
        'TINV0004231',
        'TINV0004193',
        'TINV0004194',
        'TINV0003816',
        'TINV0004123',
        'TINV0003953',
        'TINV0000201',
        'TINV0003653',
        'TINV0005657',
        'TINV0005320',
        'TINV0005185',
        'TINV0000198',
        'TINV0003566',
        'TINV0003271',
        'TINV0003373',
        'TINV0003010',
        'TINV0004858',
        'TINV0005513',
        'TINV0004236',
        'TINV0004181',
        'TINV0005519',
        'TINV0002957',
        'TINV0004132',
        'TINV0002970',
        'TINV0001341',
        'TINV0004679',
        'TINV0003264',
        'TINV0002831',
        'TINV0003712',
        'TINV0000485',
        'TINV0004121',
        'TINV0005548',
        'TINV0005205',
        'TINV0002064',
        'TINV0001214',
        'TINV0002058',
        'TINV0005296',
        'TINV0005097',
        'TINV0004653',
        'TINV0003832',
        'TINV0000211',
        'TINV0000498',
        'TINV0003817',
        'TINV0001733',
        'TINV0005299',
        'TINV0000192',
        'TINV0004819',
        'TINV0003367',
        'TINV0004237',
        'TINV0003494',
        'TINV0003833',
        'TINV0003366',
        'TINV0000242',
        'TINV0000497',
        'TINV0004048',
        'TINV0003667',
        'TINV0000500',
        'TINV0002063',
        'TINV0001727',
        'TINV0000048',
        'TINV0004820',
        'TINV0000499',
        'TINV0003341',
        'TINV0003966',
        'TINV0000486',
        'TINV0004654',
        'TINV0005370',
        'FND0011767',
        'TFND0003788',
        'INV0005996',
        'INV0005997',
        'FND0011677',
        'INV0007016',
        'INV0006784',
        'INV0007206',
        'INV0007026',
        'INV0006902',
        'INV0006864',
        'INV0006865',
        'INV0006866',
        'INV0006867',
        'INV0006868',
      ],
      labels: [
        '5R LP',
        'AFIS',
        'AMXV35demoinvestor',
        'ASB',
        'ASB2',
        'ASC 4 B',
        'ASM',
        'ASM2',
        'ASM3',
        'CM_Investor_10',
        'Caplink Investor',
        'Caplink Test case',
        'Carry Vehicle',
        'Cha Cha',
        'Dealflow Investor Fund',
        'Demo Corporation',
        'Demo Individual',
        'Demo Investor 1 TEST',
        'Demo Investor 2',
        'Demo Investor 3',
        'Demo Private Debt Fund 1 GP',
        'Demo Private Debt Fund 1 Trust',
        'Demo Private Debt Fund of Funds Euro Hedged',
        'EDL IV',
        'EMAS',
        'EMAS A Capital LLC',
        'EMAS A Real Estate 1 LLC',
        'EMAS C LLC',
        'EMAS EFA Capital LLC',
        'Emas AM1',
        'Emas AS1',
        'Emas Em1',
        'Emas2 HoldCo LLC',
        'Emas3 HoldCo LLC',
        'FUND I',
        'FUND II',
        'FUND III',
        'Feeder 1 - BO Fund',
        'Feeder 2 - BO Fund',
        'Feeder 3 - BO Fund',
        'Fund 10391',
        'Fund 11591',
        'Fund 12425',
        'Fund 12544',
        'Fund 13727',
        'Fund 14478',
        'Fund 15373',
        'Fund 168',
        'Fund 4237',
        'Fund 4417',
        'Fund 5555',
        'Fund 6038',
        'Fund 6393',
        'Fund 6458',
        'Fund 7269',
        'Fund Equity FA JP',
        'GDPR Investor 1',
        'GDPR Investor 2',
        'Investor 1601 1',
        'Investor 1601 10',
        'Investor 1601 11',
        'Investor 1601 12',
        'Investor 1601 13',
        'Investor 1601 14',
        'Investor 1601 15',
        'Investor 1601 16',
        'Investor 1601 17',
        'Investor 1601 18',
        'Investor 1601 19',
        'Investor 1601 2',
        'Investor 1601 20',
        'Investor 1601 21',
        'Investor 1601 22',
        'Investor 1601 23',
        'Investor 1601 24',
        'Investor 1601 25',
        'Investor 1601 3',
        'Investor 1601 4',
        'Investor 1601 5',
        'Investor 1601 6',
        'Investor 1601 7',
        'Investor 1601 8',
        'Investor 1601 9',
        'Investor 6815',
        'Investor 6816',
        'Investor 6818',
        'Investor 6819',
        'Investor A',
        'Investor BPR-1330-1',
        'Investor BPR-1330-2',
        'Investor10088',
        'Investor1010',
        'Investor10103',
        'Investor10230',
        'Investor10269',
        'Investor10389',
        'Investor10414',
        'Investor10435',
        'Investor1045',
        'Investor10465',
        'Investor10468',
        'Investor10563',
        'Investor10575',
        'Investor10610',
        'Investor10650',
        'Investor10660',
        'Investor10662',
        'Investor10673',
        'Investor10743',
        'Investor10747',
        'Investor10755',
        'Investor10861',
        'Investor10963',
        'Investor10964',
        'Investor10965',
        'Investor11110',
        'Investor11135',
        'Investor11151',
        'Investor11195',
        'Investor11262',
        'Investor11269',
        'Investor1130',
        'Investor11315',
        'Investor11320',
        'Investor11354',
        'Investor11363',
        'Investor11449',
        'Investor11468',
        'Investor11489',
        'Investor115',
        'Investor11501',
        'Investor11553',
        'Investor11566',
        'Investor11581',
        'Investor11618',
        'Investor11650',
        'Investor11666',
        'Investor11795',
        'Investor11807',
        'Investor11830',
        'Investor11860',
        'Investor11867',
        'Investor11870',
        'Investor11933',
        'Investor11943',
        'Investor11958',
        'Investor11976',
        'Investor11981',
        'Investor11982',
        'Investor12013',
        'Investor12020',
        'Investor12031',
        'Investor12062',
        'Investor12072',
        'Investor1210',
        'Investor12117',
        'Investor12264',
        'Investor12270',
        'Investor12308',
        'Investor1233',
        'Investor12351',
        'Investor12395',
        'Investor12416',
        'Investor12439',
        'Investor12495',
        'Investor12511',
        'Investor12631',
        'Investor12637',
        'Investor12656',
        'Investor1268',
        'Investor12843',
        'Investor12988',
        'Investor13038',
        'Investor13064',
        'Investor13082',
        'Investor13116',
        'Investor1313',
        'Investor13135',
        'Investor13186',
        'Investor1321',
        'Investor13213',
        'Investor13221',
        'Investor13292',
        'Investor13296',
        'Investor13318',
        'Investor13346',
        'Investor13367',
        'Investor13383',
        'Investor1340',
        'Investor13465',
        'Investor13521',
        'Investor13544',
        'Investor13739',
        'Investor13744',
        'Investor13770',
        'Investor13771',
        'Investor13794',
        'Investor13856',
        'Investor13910',
        'Investor13938',
        'Investor14037',
        'Investor14069',
        'Investor14071',
        'Investor14085',
        'Investor14098',
        'Investor14114',
        'Investor14167',
        'Investor14178',
        'Investor14311',
        'Investor14401',
        'Investor14427',
        'Investor14520',
        'Investor14535',
        'Investor14536',
        'Investor14553',
        'Investor14557',
        'Investor14588',
        'Investor14589',
        'Investor14595',
        'Investor14668',
        'Investor14705',
        'Investor14810',
        'Investor14883',
        'Investor14936',
        'Investor15007',
        'Investor15056',
        'Investor15095',
        'Investor15118',
        'Investor15135',
        'Investor15144',
        'Investor15151',
        'Investor15161',
        'Investor15163',
        'Investor15165',
        'Investor15203',
        'Investor15256',
        'Investor15262',
        'Investor15348',
        'Investor15356',
        'Investor15407',
        'Investor15450',
        'Investor15545',
        'Investor15575',
        'Investor15598',
        'Investor15601',
        'Investor15604',
        'Investor15639',
        'Investor15648',
        'Investor15665',
        'Investor15729',
        'Investor15764',
        'Investor15817',
        'Investor1582',
        'Investor15837',
        'Investor15970',
        'Investor16033',
        'Investor16040',
        'Investor16044',
        'Investor16118',
        'Investor16155',
        'Investor1616',
        'Investor16200',
        'Investor16229',
        'Investor16240',
        'Investor16305',
        'Investor16307',
        'Investor16324',
        'Investor16331',
        'Investor16369',
        'Investor16374',
        'Investor16378',
        'Investor16397',
        'Investor16417',
        'Investor16478',
        'Investor16591',
        'Investor16615',
        'Investor16625',
        'Investor16642',
        'Investor16648',
        'Investor16673',
        'Investor16687',
        'Investor16711',
        'Investor1676',
        'Investor16782',
        'Investor1686',
        'Investor1688',
        'Investor16888',
        'Investor16900',
        'Investor16998',
        'Investor17005',
        'Investor17061',
        'Investor17092',
        'Investor17199',
        'Investor17215',
        'Investor17231',
        'Investor17302',
        'Investor17331',
        'Investor17360',
        'Investor17465',
        'Investor17474',
        'Investor17486',
        'Investor17492',
        'Investor17645',
        'Investor17712',
        'Investor17744',
        'Investor1778',
        'Investor17802',
        'Investor17850',
        'Investor17855',
        'Investor17913',
        'Investor17939',
        'Investor17956',
        'Investor18',
        'Investor18016',
        'Investor18088',
        'Investor1816',
        'Investor18168',
        'Investor1818',
        'Investor18191',
        'Investor18198',
        'Investor1822',
        'Investor18255',
        'Investor18365',
        'Investor18393',
        'Investor18456',
        'Investor18458',
        'Investor18503',
        'Investor18535',
        'Investor18549',
        'Investor18558',
        'Investor18565',
        'Investor18583',
        'Investor18709',
        'Investor18757',
        'Investor18782',
        'Investor18820',
        'Investor18838',
        'Investor18865',
        'Investor18868',
        'Investor1894',
        'Investor18942',
        'Investor18961',
        'Investor1899',
        'Investor19002',
        'Investor19006',
        'Investor1901',
        'Investor19071',
        'Investor19239',
        'Investor19249',
        'Investor19276',
        'Investor19285',
        'Investor19316',
        'Investor19319',
        'Investor19358',
        'Investor19408',
        'Investor19414',
        'Investor1948',
        'Investor19481',
        'Investor19608',
        'Investor19654',
        'Investor19723',
        'Investor19738',
        'Investor19797',
        'Investor19813',
        'Investor2019',
        'Investor2031',
        'Investor2036',
        'Investor2062',
        'Investor2085',
        'Investor2210',
        'Investor2222',
        'Investor2281',
        'Investor2298',
        'Investor2317',
        'Investor2363',
        'Investor2452',
        'Investor2454',
        'Investor2506',
        'Investor2511',
        'Investor2515',
        'Investor2521',
        'Investor2642',
        'Investor265',
        'Investor2694',
        'Investor274',
        'Investor2758',
        'Investor281',
        'Investor2847',
        'Investor2908',
        'Investor3003',
        'Investor3042',
        'Investor3053',
        'Investor3083',
        'Investor31',
        'Investor3163',
        'Investor3172',
        'Investor3198',
        'Investor3207',
        'Investor3244',
        'Investor3252',
        'Investor3289',
        'Investor329',
        'Investor3303',
        'Investor3331',
        'Investor3402',
        'Investor342',
        'Investor3455',
        'Investor3486',
        'Investor35',
        'Investor3500',
        'Investor3517',
        'Investor3536',
        'Investor3553',
        'Investor3585',
        'Investor3618',
        'Investor3638',
        'Investor3657',
        'Investor3662',
        'Investor3686',
        'Investor3698',
        'Investor3781',
        'Investor3835',
        'Investor3944',
        'Investor3947',
        'Investor3990',
        'Investor4051',
        'Investor4055',
        'Investor4102',
        'Investor4108',
        'Investor4146',
        'Investor4171',
        'Investor4178',
        'Investor4349',
        'Investor4425',
        'Investor4479',
        'Investor4503',
        'Investor4522',
        'Investor4592',
        'Investor4603',
        'Investor4611',
        'Investor4614',
        'Investor4628',
        'Investor4664',
        'Investor4670',
        'Investor4672',
        'Investor4757',
        'Investor4784',
        'Investor48',
        'Investor4873',
        'Investor4882',
        'Investor4941',
        'Investor4949',
        'Investor4962',
        'Investor50',
        'Investor5134',
        'Investor5162',
        'Investor5190',
        'Investor521',
        'Investor5337',
        'Investor534',
        'Investor5365',
        'Investor5405',
        'Investor545',
        'Investor5458',
        'Investor5602',
        'Investor5614',
        'Investor5617',
        'Investor5642',
        'Investor5645',
        'Investor5650',
        'Investor5687',
        'Investor5885',
        'Investor589',
        'Investor5904',
        'Investor593',
        'Investor5932',
        'Investor5942',
        'Investor5955',
        'Investor5992',
        'Investor6055',
        'Investor6149',
        'Investor6185',
        'Investor6285',
        'Investor6303',
        'Investor6305',
        'Investor6328',
        'Investor6329',
        'Investor6344',
        'Investor6348',
        'Investor6363',
        'Investor6405',
        'Investor6421',
        'Investor6438',
        'Investor6458',
        'Investor650',
        'Investor6504',
        'Investor6624',
        'Investor6635',
        'Investor6657',
        'Investor6676',
        'Investor6827',
        'Investor6844',
        'Investor6853',
        'Investor6858',
        'Investor6863',
        'Investor6866',
        'Investor688',
        'Investor6902',
        'Investor697',
        'Investor6982',
        'Investor701',
        'Investor7013',
        'Investor7069',
        'Investor7071',
        'Investor7232',
        'Investor7277',
        'Investor7389',
        'Investor7440',
        'Investor7480',
        'Investor7492',
        'Investor7511',
        'Investor7524',
        'Investor7582',
        'Investor7632',
        'Investor7644',
        'Investor7655',
        'Investor7663',
        'Investor7721',
        'Investor7806',
        'Investor7815',
        'Investor7882',
        'Investor7927',
        'Investor7946',
        'Investor7982',
        'Investor8004',
        'Investor8035',
        'Investor804',
        'Investor8049',
        'Investor8078',
        'Investor8112',
        'Investor8116',
        'Investor8168',
        'Investor8187',
        'Investor8222',
        'Investor8248',
        'Investor8255',
        'Investor8263',
        'Investor8276',
        'Investor8329',
        'Investor8383',
        'Investor8407',
        'Investor8419',
        'Investor8429',
        'Investor8439',
        'Investor8468',
        'Investor8479',
        'Investor8572',
        'Investor8740',
        'Investor8847',
        'Investor8858',
        'Investor8875',
        'Investor8914',
        'Investor897',
        'Investor8979',
        'Investor9026',
        'Investor9053',
        'Investor9061',
        'Investor9089',
        'Investor9098',
        'Investor9107',
        'Investor9162',
        'Investor9253',
        'Investor9294',
        'Investor9311',
        'Investor9395',
        'Investor9413',
        'Investor9451',
        'Investor9459',
        'Investor9465',
        'Investor9511',
        'Investor9554',
        'Investor959',
        'Investor9615',
        'Investor9627',
        'Investor9635',
        'Investor9644',
        'Investor9663',
        'Investor9683',
        'Investor9690',
        'Investor9708',
        'Investor9755',
        'Investor9769',
        'Investor982',
        'Investor9908',
        'Investor991',
        'Investor9914',
        'Investor9989',
        'MF FoF Secondary',
        'PERE-3965 Test Jsy',
        'SD Investor 01',
        'SD Investor 02',
        'SPV Investor Fund',
        'TRANSFER INVESTOR',
        'Test inv',
        'TestInvestor V36',
        'Transfer Investor 2',
        'UAT TEST NEW INVESTOR',
        'UTF Emas B',
        'UTF Emas B2',
        'UTF Emas M',
        'UTF Emas M2 W',
        'UTF Emas M3',
      ],
    },

    internal_id: {
      values: [
        '35',
        '36',
        '41',
        '32',
        '15',
        '6',
        '61',
        '58',
        '4',
        '60',
        '37',
        '27',
        '33',
        '59',
        '23',
        '10',
        '42',
        '24',
        '19',
        '25',
        '7',
        '34',
        '44',
        '39',
        '17',
        '18',
        '21',
        '22',
        '40',
        '46',
        '20',
        '26',
        '30',
        '16',
        '28',
        '9',
        '29',
      ],
      labels: [
        'Advisory Board meeting',
        'Annual General meeting',
        'Annual Report',
        'By Laws',
        'Call Notice',
        'Capital Account Statement',
        'Compliance Certificate',
        'Deal Documentation',
        'Distribution Notice',
        'Drawdown/Distribution calculations',
        'ESG Report',
        'Equalization Notice',
        'Financial Statements',
        'Fund KPI Reporting',
        'General Correspondence',
        'Inventory',
        'Investor Communication',
        'Investor Meeting Notices',
        'Legal Document',
        'Legal Notices',
        'Management reports',
        'Marketing Documents',
        'Monthly Reports',
        'NAV Pack',
        'Net Capital Call Notice',
        'Net Distribution Notice',
        'Other Fund Reporting',
        'Other Investor Reporting',
        'Primary Statements',
        'Quarterly Statements',
        'Regulatory Reporting',
        'Return Notice',
        'Statement of position',
        'Tax Information',
        'Transfer Notice',
        'Trial Balance',
        'Welcome Letter',
      ],
    },

    share_type_id: {
      values: ['1', '0', '2'],
      labels: ['CARR_SHARE', 'NOT_APPLICABLE', 'ORD_SHARE'],
    },
  },
};
